import React, { useEffect, useState, useRef } from "react";
/* import { useTranslation } from "react-i18next"; */
import { useNavigate } from "react-router-dom";
import DropDownButtons from "../RoundedDropdown/DropDownButtons";
import MultiselectDropDown from "./MultiselectDropDown";
import ScrollableChipComp from "./ScrollableChipComp";
import "./searchManager.scss";
import SearchTextField from "./SearchTextField";
import { getMlrStatusList } from "../../services/apis";
import createNewIcon from "../../images/create-newIcon.svg";
import FilterIcon from "../../images/filters-image.svg";
import AdvanceFilterModal from "../AdvanceFilterModal/AdvanceFilterModal";
import DropdownCreate from "./DropdownCreate";

const SearchManagerComponent = ({
  brands,
  market,
  showCount,
  type,
  refreshComp,
  switchToCreatedBy,
  sendSearchDataToEdetails,
  createdbyMe,
  openCreateNewPresenationModal,
  marketDataList,
  searchClickEdetail,
  // openAdvanceFilterHandler,
  // brandSelected,
  // setBrandSelected,
  // marketSelected,
  // setMarketSelected,
  // mlrSelected,
  // setMlrSelected,
  countriesList,
  setCountriesList,
  brandsList,
  setBrandsList,
  mlrStatusList,
  setMLRStatusList,
  indicationList,
}) => {
  const [searchEmpty, setIsSearchBarEmpty] = useState(true);
  const [mlrList, setMlrList] = useState([]);
  const [brandSelected, setBrandSelected] = useState([]);
  const [marketSelected, setMarketSelected] = useState([]);
  const [mlrSelected, setMlrSelected] = useState([]);
  const [indicationSelected, setIndicationSelected] = useState([]);
  const [createPresentationFields, setCreatePresentationFields] = useState({});
  const [textSearch, setTextSearch] = useState([]);
  const [searchExpand, setSearchExpand] = useState(false);
  const [openAdvanceFilterModal, setOpenAdvanceFilterModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState({
    product: [],
    country: [],
    mlrStatus: [],
    indication: [],
    contentType: [],
  });
  const [contentTypeSelected, setContentTypeSelected] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    getMlrStatusList((response, err, errorCode) => {
      if (err) {
      } else {
        const list = response?.data;
        setMlrList(list);
      }
    });
  }, []);
  useEffect(() => {
    setCreatePresentationFields({
      mlrStatus: "",
      searchInput: "",
      brand: "",
      market: "",
      indication: "",
      skip: 0,
      limit: 100,
      created: "",
    });
    setBrandSelected([]);
    setMarketSelected([]);
    setMlrSelected([]);
    setIndicationSelected([]);
  }, []);

  useEffect(() => {
    setSelectedItems((prev) => ({
      ...prev,
      product: brandSelected?.length > 0 ? brandSelected : [],
    }));
  }, [brandSelected, openAdvanceFilterModal]);

  useEffect(() => {
    setSelectedItems((prev) => ({
      ...prev,
      country: marketSelected?.length > 0 ? marketSelected : [],
    }));
  }, [marketSelected, openAdvanceFilterModal]);

  useEffect(() => {
    setSelectedItems((prev) => ({
      ...prev,
      mlrStatus: mlrSelected?.length > 0 ? mlrSelected : [],
    }));
  }, [mlrSelected, openAdvanceFilterModal]);

  useEffect(() => {
    setSelectedItems((prev) => ({
      ...prev,
      indication: indicationSelected?.length > 0 ? indicationSelected : [],
    }));
  }, [indicationSelected, openAdvanceFilterModal]);

  useEffect(() => {
    setSelectedItems((pre) => ({
      ...pre,
      contentType: contentTypeSelected.length > 0 ? contentTypeSelected : [],  
    }))
  }, [contentTypeSelected, openAdvanceFilterModal])

  const getSearchCriteria = (selectedItem, selectionFor) => {
    const ids = Array.isArray(selectedItem)
      ? selectedItem.map((i) => i.id || i._id).filter(Boolean)
      : [];
    let data = {
      ...createPresentationFields,
      skip: 0,
      limit: 100,
      created: createdbyMe,
    };
    if (selectionFor === "Product") {
      setBrandSelected(selectedItem);
      setCreatePresentationFields((prev) => ({
        ...prev,
        brand: ids,
      }));
      data["brand"] = ids;
    } else if (selectionFor === "Country") {
      setMarketSelected(selectedItem);
      setCreatePresentationFields((prev) => ({
        ...prev,
        market: ids,
      }));
      data["market"] = ids;
    } else if (selectionFor === "Mlr") {
      setMlrSelected(selectedItem);
      setCreatePresentationFields({
        ...createPresentationFields,
        mlrStatus: ids,
      });
      // data["mlrStatus"] = selectedItem;
      data["mlrStatus"] = ids;
    } else if (selectionFor === "Indication") {
      setIndicationSelected(selectedItem);
      setCreatePresentationFields({
        ...createPresentationFields,
        mlrStatus: ids,
      });
      data["indication"] = ids;
    } else if (selectionFor === "Content Type") {
      setContentTypeSelected(selectedItem);
      setCreatePresentationFields({
        ...createPresentationFields,
        contentType: contentTypeSelected,
      })
    } else if (selectionFor === "reset") {
      data["brand"] = "";
      data["market"] = "";
      data["mlrStatus"] = "";
      data["indication"] = "";
      data["searchInput"] = "";
      data["contentType"] = "";
      setCreatePresentationFields({
        ...createPresentationFields,
        brand: [],
        market: [],
        mlrStatus: [],
        indication: [],
        searchInput: "",
        contentType: [],
      });
      setBrandSelected([]);
      setMarketSelected([]);
      setMlrSelected([]);
      setIndicationSelected([]);
      setTextSearch([]);
      setContentTypeSelected([]);
    } else if (selectionFor === "remove") {
      const nameOfSelection = selectedItem?.name || selectedItem;
      setBrandSelected(
        brandSelected?.filter((brand) => brand.name !== nameOfSelection)
      );
      setMarketSelected(
        marketSelected.filter((market) => market.name !== nameOfSelection)
      );
      setMlrSelected(mlrSelected.filter((mlr) => mlr.name !== nameOfSelection));
      setIndicationSelected(
        indicationSelected.filter((ind) => ind.name !== nameOfSelection)
      );
      setTextSearch(textSearch.filter((text) => text !== nameOfSelection));
      setContentTypeSelected(
        contentTypeSelected.filter((ct) => ct.name !== nameOfSelection)
      );
      if (
        brandSelected?.findIndex((brand) => brand.name == nameOfSelection) > -1
      ) {
        setCreatePresentationFields({
          ...createPresentationFields,
          brand: brandSelected
            ?.filter((brand) => brand.name !== nameOfSelection)
            .map((i) => i.id),
        });
        data["brand"] = brandSelected
          ?.filter((brand) => brand.name !== nameOfSelection)
          .map((i) => i.id);
      } else if (
        marketSelected.findIndex((markets) => markets.name == nameOfSelection) >
        -1
      ) {
        setCreatePresentationFields({
          ...createPresentationFields,
          market: marketSelected
            ?.filter((market) => market.name !== nameOfSelection)
            .map((i) => i._id),
        });
        data["market"] = marketSelected
          ?.filter((market) => market.name !== nameOfSelection)
          .map((i) => i._id);
        // setCreatePresentationFields({
        //   ...createPresentationFields,
        //   market:
        //     marketSelected.filter((markets) => markets.name !== nameOfSelection)
        //       ? ""
        //       : marketDataList[market.indexOf(selectedItem)]._id,
        // });
        // data["market"] =
        //   marketSelected.filter((markets) => markets.name !== nameOfSelection).length < 1
        //     ? ""
        //     : marketDataList[market.indexOf(selectedItem)]._id;
      } else if (
        mlrSelected.findIndex((mlr) => mlr.name === nameOfSelection) > -1
      ) {
        setCreatePresentationFields({
          ...createPresentationFields,
          mlrStatus: mlrSelected
            ?.filter((mlr) => mlr.name !== nameOfSelection)
            .map((i) => i.name),
        });
        data["mlrStatus"] = mlrSelected
          ?.filter((mlr) => mlr.name !== nameOfSelection)
          .map((i) => i.name);
      } else if (
        indicationSelected.findIndex((ind) => ind.name === nameOfSelection) > -1
      ) {
        setCreatePresentationFields({
          ...createPresentationFields,
          indication: indicationSelected
            ?.filter((ind) => ind.name !== nameOfSelection)
            .map((i) => i?.veevaid),
        });
        data["indication"] = indicationSelected
          ?.filter((ind) => ind.name !== nameOfSelection)
          .map((i) => i?.veevaid);
      } else if (
        textSearch.findIndex((text) => text === nameOfSelection) > -1
      ) {
        setCreatePresentationFields({
          ...createPresentationFields,
          searchInput:
            textSearch.findIndex((text) => text === nameOfSelection) > -1
              ? ""
              : nameOfSelection,
        });
        data["searchInput"] =
          textSearch.findIndex((text) => text === nameOfSelection) > -1
            ? ""
            : nameOfSelection;
      } else if(
         contentTypeSelected.findIndex((ct) => ct.name === nameOfSelection) > -1
      ) {
        setCreatePresentationFields({
          ...createPresentationFields,
          contentType: contentTypeSelected
            ?.filter(ct => ct.name !== nameOfSelection)
            .map(ct => ct.value),
        })
        data["contentType"] = contentTypeSelected
          ?.filter(ct => ct.name !== nameOfSelection)
          .map(ct => ct.value);
      }
    }

    sendSearchDataToEdetails(data, "search", selectionFor);
  };
  useEffect(() => {
    // sendSearchDataToEdetails(createPresentationFields, "search");
  }, [createPresentationFields]);

  const openAdvanceFilterHandler = (type) => {
    if (type === "click") {
      setOpenAdvanceFilterModal(true);
    } else if ("cancel") {
      setOpenAdvanceFilterModal(false);
    }
  };

  const totalCount = Object.values(selectedItems).flatMap((arr) => arr)?.length;

  const handleCreateOption = (option) => {
    setDropdownOpen(false);
    if (option === "module") {
      // Existing flow - open the modal
      openCreateNewPresenationModal();
    } else if (option === "pdf") {
      // New PDF flow - navigate to PDF import page
      navigate("/import-pdf");
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <>
      <div className="filter-container">
        <div className="col-md-33" style={{ flex: "0 0 250px" }}>
          <DropDownButtons
            showCount={showCount}
            setCreatePresentationFields={setCreatePresentationFields}
            createPresentationFields={createPresentationFields}
            switchToCreatedBy={switchToCreatedBy}
            searchClickEdetail={searchClickEdetail}
            sendSearchDataToEdetails={sendSearchDataToEdetails}
          />
        </div>
        <div
          className="col-md-99"
          style={{
            flex: "1",
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <MultiselectDropDown
            data={brands}
            title={"Product"}
            setIsSearchBarEmpty={setIsSearchBarEmpty}
            multiple={true}
            setCreatePresentationFields={setCreatePresentationFields}
            createPresentationFields={createPresentationFields}
            getSearchCriteria={getSearchCriteria}
            selectedFilterData={brandSelected}
            searchExpand={searchExpand}
          />

          <MultiselectDropDown
            data={market}
            title={"Country"}
            setIsSearchBarEmpty={setIsSearchBarEmpty}
            multiple={true}
            setCreatePresentationFields={setCreatePresentationFields}
            createPresentationFields={createPresentationFields}
            getSearchCriteria={getSearchCriteria}
            selectedFilterData={marketSelected}
            searchExpand={searchExpand}
          />

          {/* <MultiselectDropDown
            data={mlrList}
            title={"MLR Status"}
            setIsSearchBarEmpty={setIsSearchBarEmpty}
            multiple={false}
            setCreatePresentationFields={setCreatePresentationFields}
            createPresentationFields={createPresentationFields}
            getSearchCriteria={getSearchCriteria}
            selectedFilterData={mlrSelected}
            searchExpand={searchExpand}
          /> */}

          <div
            className="advance-filter-btn"
            onClick={() => openAdvanceFilterHandler("click")}
          >
            <img src={FilterIcon} alt="" />
            <span className="filterLabel">Filters</span>
            {totalCount !== 0 && (
              <span className="filtersBadge">{totalCount}</span>
            )}
          </div>
          <SearchTextField
            style={{ width: "200px" }}
            expandable={true}
            setSearchExpand={setSearchExpand}
            onTextChange={(value) => {
              setCreatePresentationFields({
                ...createPresentationFields,
                searchInput: value,
              });
              value && setTextSearch([value]);
              sendSearchDataToEdetails(
                {
                  ...createPresentationFields,
                  searchInput: value,
                  created: createdbyMe,
                },
                "search"
              );
            }}
            createPresentationFields={createPresentationFields}
            placeholder={"Search by Name / ID"}
          />

          {type === 2 ? (
            <div ref={dropdownRef} className="create-new-dropdown" style={{ position: "relative" }}>
              <button
                className="create-new-button"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                type="button"
              >
                <img
                  src={createNewIcon}
                  alt="create new"
                  className="button-icon"
                />
                <span className="button-text">CREATE NEW E-DETAIL</span>
                <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`dropdown-arrow ${dropdownOpen ? "open" : ""}`}
                >
                  <path
                    d="M1 1L5 5L9 1"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <DropdownCreate
                options={["Using Editor", "Using PDF"]}
                isOpen={dropdownOpen}
                onSelectOption={(option) => {
                  if (option === "Using Editor") {
                    handleCreateOption("module");
                  } else if (option === "Using PDF") {
                    handleCreateOption("pdf");
                  }
                }}
              />
            </div>
          ) : (
            <div
              className="create-new-button"
              onClick={openCreateNewPresenationModal}
            >
              <img
                src={createNewIcon}
                style={{ marginRight: "6px" }}
                alt="create new"
              />
              Create New Template
            </div>
          )}
        </div>
      </div>
      {[
        ...brandSelected,
        ...marketSelected,
        ...mlrSelected,
        ...indicationSelected,
        ...textSearch,
        ...contentTypeSelected,
      ].length > 0 ? (
        <div
          className="col-md-12"
          style={{ padding: "0px 20px", backgroundColor: "#f3f6fa" }}
        >
          <div className="scrollchipcomp">
            <ScrollableChipComp
              filterDataToDisplay={[
                ...brandSelected,
                ...marketSelected,
                ...mlrSelected,
                ...indicationSelected,
                ...textSearch,
                ...contentTypeSelected,
              ]}
              handleReset={getSearchCriteria}
            />
          </div>
        </div>
      ) : (
        <div
          className="col-md-12"
          style={{ height: "12px", backgroundColor: "#f3f6fa" }}
        ></div>
      )}
      {openAdvanceFilterModal && (
        <AdvanceFilterModal
          openAdvanceFilterModal={openAdvanceFilterModal}
          setOpenAdvanceFilterModal={setOpenAdvanceFilterModal}
          openAdvanceFilterHandler={openAdvanceFilterHandler}
          countriesList={countriesList}
          setCountriesList={setCountriesList}
          brandsList={brandsList}
          setBrandsList={setBrandsList}
          mlrStatusList={mlrStatusList}
          setMLRStatusList={setMLRStatusList}
          brandSelected={brandSelected}
          setBrandSelected={setBrandSelected}
          marketSelected={marketSelected}
          setMarketSelected={setMarketSelected}
          mlrSelected={mlrSelected}
          setMlrSelected={setMlrSelected}
          setSelectedItems={setSelectedItems}
          selectedItems={selectedItems}
          indicationList={indicationList}
          indicationSelected={indicationSelected}
          setIndicationSelected={setIndicationSelected}
          getSearchCriteria={getSearchCriteria}
          setCreatePresentationFields={setCreatePresentationFields}
          createPresentationFields={createPresentationFields}
          createdbyMe={createdbyMe}
          sendSearchDataToEdetails={sendSearchDataToEdetails}
          totalCount={totalCount}
          setTextSearch={setTextSearch}
          setContentTypeSelected={setContentTypeSelected}
          contentTypeSelected={contentTypeSelected}
          type={type}
        />
      )}
    </>
  );
};
export default SearchManagerComponent;
